import TermsOfUse from "./TermsOfUse";


export default {
    name     : 'dialog_terms',
    component: TermsOfUse,
    dialog   : {
        'max-width': "500px"
    }
}
